import * as token from "@universityofmaryland/web-token-library";
import * as animation from "@universityofmaryland/web-styles-library/animation";
import { jssToCSS } from "@universityofmaryland/web-utilities-library/styles";
import { wrapLinkForAnimation } from "@universityofmaryland/web-utilities-library/animation";
const Attributes = {
  names: {
    theme: "theme"
  },
  values: {
    theme: {
      DARK: "dark"
    }
  }
};
const IS_THEME_DARK = `[${Attributes.names.theme}=${Attributes.values.theme.DARK}]`;
const ELEMENT_CONTAINER = "breadcrumb-container";
const ELEMENT_PATH = "breadcrumb-path";
const OVERWRITE_THEME_DARK_CONTAINER = `.${ELEMENT_CONTAINER}${IS_THEME_DARK}`;
const OVERWRITE_THEME_DARK_PATH = `${OVERWRITE_THEME_DARK_CONTAINER} .${ELEMENT_PATH}`;
const OverwriteThemeStyles = `
  ${OVERWRITE_THEME_DARK_CONTAINER} * {
    color: ${token.color.white};
  }

  ${OVERWRITE_THEME_DARK_PATH} + *::before {
    background-color: ${token.color.gray.dark};
  }
  
  ${jssToCSS({
  styleObj: {
    [`${OVERWRITE_THEME_DARK_PATH}:not(:last-child)`]: animation.line.slideUnderGrayDarkRed
  }
})}
`;
const PathStyles = `
  .${ELEMENT_PATH}::-webkit-scrollbar { 
    display: none;
  }

  .${ELEMENT_PATH}:last-child {
    color: ${token.color.black};
  }

  .${ELEMENT_PATH}:not(:last-child) {
    margin-right: 14px;
  }

  .${ELEMENT_PATH} + *::before {
    content: '';
    display: inline-block;
    height: 14px;
    background-color: ${token.color.gray.dark};
    left: -8px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%) rotate(15deg);
    width: 1px;
  }
`;
const ContainerStyles = `
  .${ELEMENT_CONTAINER} {
    display: flex;
    padding-right: 24px;
    font-size: 12px;
    padding-bottom: 1px;
    overflow-x: auto;
    scrollbar-width: none;
    white-space: nowrap;
    mask-image: linear-gradient(90deg, ${token.color.white} calc(100% - 24px), transparent);
  }

  .${ELEMENT_CONTAINER} * {
    color: ${token.color.gray.mediumAA};
    position: relative;
  }

  ${jssToCSS({
  styleObj: {
    [`.${ELEMENT_CONTAINER} a:not(:last-child)`]: animation.line.slideUnderGrayRed
  }
})}
`;
const CreateBreadcrumbElement = ({ isThemeDark, linkListSlot }) => {
  const links = linkListSlot.querySelectorAll("a");
  let styles = `
    ${ContainerStyles}
    ${PathStyles}
    ${OverwriteThemeStyles}
  `;
  if (isThemeDark)
    linkListSlot.setAttribute(
      Attributes.names.theme,
      Attributes.values.theme.DARK
    );
  linkListSlot.classList.add(ELEMENT_CONTAINER);
  for (const linkElement of links) {
    linkElement.classList.add(ELEMENT_PATH);
    wrapLinkForAnimation({
      element: linkElement
    });
  }
  return { element: linkListSlot, styles };
};
const createCompositeNavigationBreadcrumb = CreateBreadcrumbElement;
export {
  createCompositeNavigationBreadcrumb
};
//# sourceMappingURL=index.js.map
